import { type ColorFormat as ColorFormatType, colorFormats } from "store/features/colorPicker/types";

interface ColorFormatsProps {
    selectedColorFormat: ColorFormatType;
    setSelectedColorFormat: (value: ColorFormatType) => void;
}

export const ColorFormats = ({ selectedColorFormat, setSelectedColorFormat }: ColorFormatsProps) => {
    return (
        <div className="flex flex-wrap gap-2">
            {colorFormats
                .filter((cf) => cf !== "hex")
                .map((colorFormat) => (
                    <ColorFormat
                        key={colorFormat}
                        colorFormat={colorFormat}
                        selectedColorFormat={selectedColorFormat}
                        setSelectedColorFormat={setSelectedColorFormat}
                    />
                ))}
        </div>
    );
};

interface ColorFormatProps extends ColorFormatsProps {
    colorFormat: ColorFormatType & Exclude<string, ColorFormatType>;
}

const ColorFormat = ({ colorFormat, selectedColorFormat, setSelectedColorFormat }: ColorFormatProps) => (
    <button
        key={colorFormat}
        className={`uppercase px-3 my-2 py-1 rounded-lg ${
            selectedColorFormat === colorFormat
                ? `bg-irBlue-200 lg:hover:bg-irBlue-400 dark:bg-darkPrimary-100 dark:hover:bg-darkPrimary-200 text-white`
                : `bg-irGray-200 dark:bg-darkSurface-200 lg:hover:bg-irGray-400 dark:hover:bg-darkSurface-300`
        }`}
        onClick={() => setSelectedColorFormat(colorFormat)}
    >
        {colorFormat}
    </button>
);
